import React, { useState } from 'react';
import { TrendingUpIcon, TrendingDownIcon, CalendarIcon, ClockIcon } from 'lucide-react';
const TeamComboDuos = () => {
  // State for filters
  const [minSharedMinutes, setMinSharedMinutes] = useState(20);
  const [competition, setCompetition] = useState('regular');
  const [season, setSeason] = useState('2023-24');
  const [timeWindow, setTimeWindow] = useState('season');
  const [metric, setMetric] = useState('netRtg');
  const [normalizeVsTeam, setNormalizeVsTeam] = useState(true);
  // Team average Net Rating
  const teamAvgNetRating = 3.8;
  // Mock player data with more players to match the image
  const players = [{
    id: 1,
    name: 'ADRIAN',
    shortName: 'Adrian',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629675.png'
  }, {
    id: 2,
    name: 'DE NEGRI',
    shortName: 'De Negri',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628404.png'
  }, {
    id: 3,
    name: 'PECCHIA',
    shortName: 'Pecchia',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628384.png'
  }, {
    id: 4,
    name: 'GOLDEN',
    shortName: 'Golden',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1626162.png'
  }, {
    id: 5,
    name: 'MCCULLOUGH',
    shortName: 'McCullough',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628392.png'
  }, {
    id: 6,
    name: 'LACEY',
    shortName: 'Lacey',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628978.png'
  }, {
    id: 7,
    name: 'ZEGAROWSKI',
    shortName: 'Zegarowski',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629667.png'
  }, {
    id: 8,
    name: 'ZANOTTI',
    shortName: 'Zanotti',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629011.png'
  }, {
    id: 9,
    name: 'PICCOLI',
    shortName: 'Piccoli',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1629675.png'
  }, {
    id: 10,
    name: 'EBOUA',
    shortName: 'Eboua',
    avatar: 'https://cdn.nba.com/headshots/nba/latest/1040x760/1628404.png'
  }];
  // Mock duo data with more varied values
  const duoData = {
    '1-2': {
      value: -12.5,
      minutes: 82,
      possessions: 180,
      offRtg: 98.5,
      defRtg: 115.2
    },
    '1-3': {
      value: -10.1,
      minutes: 65,
      possessions: 145,
      offRtg: 100.2,
      defRtg: 114.5
    },
    '1-4': {
      value: -7.8,
      minutes: 78,
      possessions: 170,
      offRtg: 102.5,
      defRtg: 114.5
    },
    '1-5': {
      value: -5.4,
      minutes: 92,
      possessions: 200,
      offRtg: 105.8,
      defRtg: 115.4
    },
    '1-6': {
      value: -3.0,
      minutes: 55,
      possessions: 120,
      offRtg: 108.2,
      defRtg: 115.4
    },
    '1-7': {
      value: -0.6,
      minutes: 70,
      possessions: 155,
      offRtg: 110.5,
      defRtg: 115.3
    },
    '1-8': {
      value: 1.8,
      minutes: 51,
      possessions: 112,
      offRtg: 112.8,
      defRtg: 115.2
    },
    '1-9': {
      value: 4.2,
      minutes: 62,
      possessions: 138,
      offRtg: 115.2,
      defRtg: 115.2
    },
    '1-10': {
      value: 6.6,
      minutes: 35,
      possessions: 78,
      offRtg: 117.8,
      defRtg: 115.4
    },
    '2-3': {
      value: -3.0,
      minutes: 70,
      possessions: 155,
      offRtg: 108.2,
      defRtg: 115.4
    },
    '2-4': {
      value: 1.8,
      minutes: 82,
      possessions: 180,
      offRtg: 112.8,
      defRtg: 115.2
    },
    '2-5': {
      value: 6.6,
      minutes: 95,
      possessions: 210,
      offRtg: 117.8,
      defRtg: 115.4
    },
    '2-6': {
      value: 11.4,
      minutes: 62,
      possessions: 138,
      offRtg: 122.6,
      defRtg: 115.4
    },
    '2-7': {
      value: 16.2,
      minutes: 35,
      possessions: 78,
      offRtg: 127.4,
      defRtg: 115.4
    },
    '2-8': {
      value: 21.0,
      minutes: 70,
      possessions: 155,
      offRtg: 132.2,
      defRtg: 115.4
    },
    '2-9': {
      value: 25.7,
      minutes: 82,
      possessions: 180,
      offRtg: 136.9,
      defRtg: 115.4
    },
    '2-10': {
      value: -29.5,
      minutes: 55,
      possessions: 120,
      offRtg: 81.7,
      defRtg: 115.4
    },
    '3-4': {
      value: 11.4,
      minutes: 70,
      possessions: 155,
      offRtg: 122.6,
      defRtg: 115.4
    },
    '3-5': {
      value: 18.6,
      minutes: 62,
      possessions: 138,
      offRtg: 129.8,
      defRtg: 115.4
    },
    '3-6': {
      value: 25.7,
      minutes: 35,
      possessions: 78,
      offRtg: 136.9,
      defRtg: 115.4
    },
    '3-7': {
      value: -27.1,
      minutes: 70,
      possessions: 155,
      offRtg: 84.1,
      defRtg: 115.4
    },
    '3-8': {
      value: -19.9,
      minutes: 82,
      possessions: 180,
      offRtg: 91.3,
      defRtg: 115.4
    },
    '3-9': {
      value: -12.7,
      minutes: 55,
      possessions: 120,
      offRtg: 98.5,
      defRtg: 115.4
    },
    '3-10': {
      value: -5.6,
      minutes: 62,
      possessions: 138,
      offRtg: 105.6,
      defRtg: 115.4
    },
    '4-5': {
      value: -29.5,
      minutes: 70,
      possessions: 155,
      offRtg: 81.7,
      defRtg: 115.4
    },
    '4-6': {
      value: -19.9,
      minutes: 35,
      possessions: 78,
      offRtg: 91.3,
      defRtg: 115.4
    },
    '4-7': {
      value: -10.3,
      minutes: 70,
      possessions: 155,
      offRtg: 100.9,
      defRtg: 115.4
    },
    '4-8': {
      value: -0.8,
      minutes: 82,
      possessions: 180,
      offRtg: 110.4,
      defRtg: 115.4
    },
    '4-9': {
      value: 8.8,
      minutes: 55,
      possessions: 120,
      offRtg: 120.0,
      defRtg: 115.4
    },
    '4-10': {
      value: 18.4,
      minutes: 62,
      possessions: 138,
      offRtg: 129.6,
      defRtg: 115.4
    },
    '5-6': {
      value: -5.6,
      minutes: 70,
      possessions: 155,
      offRtg: 105.6,
      defRtg: 115.4
    },
    '5-7': {
      value: 6.4,
      minutes: 35,
      possessions: 78,
      offRtg: 117.6,
      defRtg: 115.4
    },
    '5-8': {
      value: 18.4,
      minutes: 70,
      possessions: 155,
      offRtg: 129.6,
      defRtg: 115.4
    },
    '5-9': {
      value: -29.7,
      minutes: 82,
      possessions: 180,
      offRtg: 81.5,
      defRtg: 115.4
    },
    '5-10': {
      value: -17.7,
      minutes: 55,
      possessions: 120,
      offRtg: 93.5,
      defRtg: 115.4
    },
    '6-7': {
      value: 23.2,
      minutes: 62,
      possessions: 138,
      offRtg: 134.4,
      defRtg: 115.4
    },
    '6-8': {
      value: -22.5,
      minutes: 70,
      possessions: 155,
      offRtg: 88.7,
      defRtg: 115.4
    },
    '6-9': {
      value: -8.1,
      minutes: 35,
      possessions: 78,
      offRtg: 103.1,
      defRtg: 115.4
    },
    '6-10': {
      value: 6.2,
      minutes: 70,
      possessions: 155,
      offRtg: 117.4,
      defRtg: 115.4
    },
    '7-8': {
      value: -3.4,
      minutes: 82,
      possessions: 180,
      offRtg: 107.8,
      defRtg: 115.4
    },
    '7-9': {
      value: 13.4,
      minutes: 55,
      possessions: 120,
      offRtg: 124.6,
      defRtg: 115.4
    },
    '7-10': {
      value: -29.9,
      minutes: 62,
      possessions: 138,
      offRtg: 81.3,
      defRtg: 115.4
    },
    '8-9': {
      value: -25.1,
      minutes: 70,
      possessions: 155,
      offRtg: 86.1,
      defRtg: 115.4
    },
    '8-10': {
      value: -5.9,
      minutes: 35,
      possessions: 78,
      offRtg: 105.3,
      defRtg: 115.4
    },
    '9-10': {
      value: 18.0,
      minutes: 70,
      possessions: 155,
      offRtg: 129.2,
      defRtg: 115.4
    }
  };
  // Get duo value
  const getDuoValue = (player1Id: number, player2Id: number) => {
    if (player1Id === player2Id) return null;
    const key = `${Math.min(player1Id, player2Id)}-${Math.max(player1Id, player2Id)}`;
    return duoData[key] || null;
  };
  // Enhanced color mapping for stronger contrast
  const getColorForValue = (value: number) => {
    if (value === null) return '#f3f4f6';
    const normalized = Math.max(-30, Math.min(30, value));
    if (normalized < -15) {
      // Deep red
      return '#dc2626';
    } else if (normalized < -10) {
      // Red
      return '#ef4444';
    } else if (normalized < -5) {
      // Light red
      return '#f87171';
    } else if (normalized < -2) {
      // Very light red
      return '#fca5a5';
    } else if (normalized < 2) {
      // Neutral/white
      return '#fef3c7';
    } else if (normalized < 5) {
      // Very light green
      return '#bbf7d0';
    } else if (normalized < 10) {
      // Light green
      return '#86efac';
    } else if (normalized < 15) {
      // Green
      return '#4ade80';
    } else {
      // Deep green
      return '#22c55e';
    }
  };
  // Get text color for contrast
  const getTextColor = (value: number) => {
    if (value === null) return 'text-gray-400';
    const absValue = Math.abs(value);
    if (absValue > 15) return 'text-white font-bold';
    if (absValue > 10) return 'text-gray-900 font-bold';
    return 'text-gray-800 font-semibold';
  };
  // Best and worst duos
  const sortedDuos = Object.entries(duoData).map(([key, data]) => {
    const [p1, p2] = key.split('-').map(Number);
    const player1 = players.find(p => p.id === p1);
    const player2 = players.find(p => p.id === p2);
    return {
      player1,
      player2,
      ...data
    };
  }).sort((a, b) => b.value - a.value);
  const bestDuos = sortedDuos.slice(0, 3);
  const worstDuos = sortedDuos.slice(-3).reverse();
  // Tooltip state
  const [tooltip, setTooltip] = useState<{
    visible: boolean;
    x: number;
    y: number;
    data: any;
  }>({
    visible: false,
    x: 0,
    y: 0,
    data: null
  });
  const showTooltip = (e: React.MouseEvent, player1: any, player2: any, duoInfo: any) => {
    if (!duoInfo) return;
    setTooltip({
      visible: true,
      x: e.clientX,
      y: e.clientY,
      data: {
        player1: player1.shortName,
        player2: player2.shortName,
        ...duoInfo
      }
    });
  };
  const hideTooltip = () => {
    setTooltip({
      visible: false,
      x: 0,
      y: 0,
      data: null
    });
  };
  return <div className="bg-gray-50" data-id="element-200" data-mp="2ctzm1bgvdp4b">
      {/* Compact Filters Bar */}
      <div className="bg-white border-b border-gray-200 px-6 py-3" data-id="element-201" data-mp="2hsaupivfhtky">
        <div className="flex items-center gap-6" data-id="element-202" data-mp="2hsj616bwkqu1">
          {/* Min Minutes */}
          <div className="flex items-center gap-2" data-id="element-203" data-mp="35j6p8nr9r2vw">
            <span className="text-xs font-medium text-gray-600" data-id="element-204" data-mp="39j776idktw7p">
              Min Minutes
            </span>
            <div className="flex items-center gap-2 bg-blue-50 rounded-full px-3 py-1" data-id="element-205" data-mp="2vk7ixbtz7jc2">
              <input type="range" min="0" max="100" step="5" value={minSharedMinutes} onChange={e => setMinSharedMinutes(Number(e.target.value))} className="w-20 h-1" data-id="element-206" data-mp="30iisrmk9ttua" />
              <span className="text-sm font-bold text-blue-600" data-id="element-207" data-mp="1k6lvpw7ofrt6">
                {minSharedMinutes}+
              </span>
            </div>
          </div>

          {/* Competition */}
          <button className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm hover:bg-gray-50" data-id="element-208" data-mp="1hi9qowli9eao">
            <span className="text-gray-400" data-id="element-209" data-mp="1qksp94i9d4r4">🏆</span>
            <span className="font-medium" data-id="element-210" data-mp="1qk98hr4cgmeo">Regular Season</span>
          </button>

          {/* Season */}
          <button className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm hover:bg-gray-50" data-id="element-211" data-mp="1lm7u3jhv5b9j">
            <CalendarIcon className="w-4 h-4 text-gray-400" data-id="element-212" data-mp="tuihi1v9hhdm" />
            <span className="font-medium" data-id="element-213" data-mp="tw37de6msc55">2023-24</span>
          </button>

          {/* Time Window */}
          <button className="flex items-center gap-2 px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-sm hover:bg-gray-50" data-id="element-214" data-mp="17n83w7epcob9">
            <ClockIcon className="w-4 h-4 text-gray-400" data-id="element-215" data-mp="f5chibolnn4o" />
            <span className="font-medium" data-id="element-216" data-mp="f3t20narpg3y">Season Total</span>
          </button>

          {/* Metric Tabs */}
          <div className="flex items-center bg-gray-100 rounded-lg p-0.5" data-id="element-217" data-mp="a4ggq6zjoh3h">
            <button onClick={() => setMetric('netRtg')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${metric === 'netRtg' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-218" data-mp="2a897dmc1swoq">
              Net Rtg
            </button>
            <button onClick={() => setMetric('offRtg')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${metric === 'offRtg' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-219" data-mp="2oy6mzdvwwe2b">
              Off Rtg
            </button>
            <button onClick={() => setMetric('defRtg')} className={`px-4 py-1.5 text-sm font-medium rounded-md transition-colors ${metric === 'defRtg' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-220" data-mp="1wb3vv6tkf5m3">
              Def Rtg
            </button>
          </div>

          {/* Normalize Toggle */}
          <div className="ml-auto flex items-center gap-2" data-id="element-221" data-mp="3gouoir1hzlgi">
            <span className="text-sm text-gray-600" data-id="element-222" data-mp="3gn9ud2j3i4j6">Normalize vs Team Avg</span>
            <button onClick={() => setNormalizeVsTeam(!normalizeVsTeam)} className={`relative w-11 h-6 rounded-full transition-colors ${normalizeVsTeam ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-223" data-mp="150g2vhnezmyn">
              <div className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full transition-transform ${normalizeVsTeam ? 'translate-x-5' : ''}`} data-id="element-224" data-mp="w8e3lmp30cpy" />
            </button>
          </div>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="px-6 py-4" data-id="element-225" data-mp="mcb12fqbic2h">
        <div className="grid grid-cols-2 gap-4" data-id="element-226" data-mp="hc6jemdobbao">
          {/* Best Duos */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-4" data-id="element-227" data-mp="he9jy0cgcmtn">
            <div className="flex items-center gap-2 mb-3" data-id="element-228" data-mp="dalbzgjwrp7v">
              <TrendingUpIcon className="w-5 h-5 text-green-600" data-id="element-229" data-mp="8c0e3ns4phml" />
              <h3 className="font-bold text-sm text-gray-900" data-id="element-230" data-mp="27ochq4z49oy1">
                TOP 3 EFFICIENT DUOS
              </h3>
            </div>
            <div className="space-y-3" data-id="element-231" data-mp="22qb1drt2s3q9">
              {bestDuos.map((duo, idx) => <div key={idx} className="flex items-center justify-between bg-white rounded-lg p-3 border border-green-100" data-id="element-232" data-mp="zelre8ydbo00" data-mpi={idx}>
                  <div className="flex items-center gap-3" data-id="element-233" data-mp="14dovnr6ixq6x">
                    <div className="flex -space-x-2" data-id="element-234" data-mp="qdnyalpgx0w7">
                      <img src={duo.player1?.avatar} alt={duo.player1?.shortName} className="w-10 h-10 rounded-full border-2 border-white object-cover" onError={e => {
                    e.currentTarget.src = `https://via.placeholder.com/40x40/e5e7eb/6b7280?text=${duo.player1?.shortName?.charAt(0)}`;
                  }} data-id="element-235" data-mp="qcw1j7k4wx4c" />
                      <img src={duo.player2?.avatar} alt={duo.player2?.shortName} className="w-10 h-10 rounded-full border-2 border-white object-cover" onError={e => {
                    e.currentTarget.src = `https://via.placeholder.com/40x40/e5e7eb/6b7280?text=${duo.player2?.shortName?.charAt(0)}`;
                  }} data-id="element-236" data-mp="lgnt0d0g0265" />
                    </div>
                    <div data-id="element-237" data-mp="2octmt4zymcs">
                      <div className="text-sm font-bold text-gray-900" data-id="element-238" data-mp="2njw8irxh97b">
                        {duo.player1?.shortName} & {duo.player2?.shortName}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-239" data-mp="3a9nsqxrsi1pj">
                        {duo.minutes} min
                      </div>
                    </div>
                  </div>
                  <div className="text-xl font-bold text-green-600" data-id="element-240" data-mp="3k68yxmfjpiuy">
                    +{duo.value.toFixed(1)}
                  </div>
                </div>)}
            </div>
          </div>

          {/* Worst Duos */}
          <div className="bg-red-50 border border-red-200 rounded-lg p-4" data-id="element-241" data-mp="3t6f8wyc1c0pd">
            <div className="flex items-center gap-2 mb-3" data-id="element-242" data-mp="bri6z8v2dxqn">
              <TrendingDownIcon className="w-5 h-5 text-red-600" data-id="element-243" data-mp="bt1nn0kmuasy" />
              <h3 className="font-bold text-sm text-gray-900" data-id="element-244" data-mp="6sx93g3abq5d">
                LOWEST EFFICIENT DUOS
              </h3>
            </div>
            <div className="space-y-3" data-id="element-245" data-mp="kpkgydws00q2">
              {worstDuos.map((duo, idx) => <div key={idx} className="flex items-center justify-between bg-white rounded-lg p-3 border border-red-100" data-id="element-246" data-mp="grd0zla4z3fx" data-mpi={idx}>
                  <div className="flex items-center gap-3" data-id="element-247" data-mp="nr5eov55sydo">
                    <div className="flex -space-x-2" data-id="element-248" data-mp="ste8tutrq6hd">
                      <img src={duo.player1?.avatar} alt={duo.player1?.shortName} className="w-10 h-10 rounded-full border-2 border-white object-cover" onError={e => {
                    e.currentTarget.src = `https://via.placeholder.com/40x40/e5e7eb/6b7280?text=${duo.player1?.shortName?.charAt(0)}`;
                  }} data-id="element-249" data-mp="xrfr4djde1rs" />
                      <img src={duo.player2?.avatar} alt={duo.player2?.shortName} className="w-10 h-10 rounded-full border-2 border-white object-cover" onError={e => {
                    e.currentTarget.src = `https://via.placeholder.com/40x40/e5e7eb/6b7280?text=${duo.player2?.shortName?.charAt(0)}`;
                  }} data-id="element-250" data-mp="1bib15t5luowy" />
                    </div>
                    <div data-id="element-251" data-mp="3ibd9bbok066j">
                      <div className="text-sm font-bold text-gray-900" data-id="element-252" data-mp="3n8dbvcm72qsw">
                        {duo.player1?.shortName} & {duo.player2?.shortName}
                      </div>
                      <div className="text-xs text-gray-500" data-id="element-253" data-mp="24fdbp3i99qjr">
                        {duo.minutes} min
                      </div>
                    </div>
                  </div>
                  <div className="text-xl font-bold text-red-600" data-id="element-254" data-mp="1vlgnzk9g0628">
                    {duo.value.toFixed(1)}
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {/* Heatmap Matrix */}
      <div className="px-6 pb-6" data-id="element-255" data-mp="2jajfdjtvpd9x">
        <div className="bg-white rounded-lg border border-gray-200 overflow-hidden" data-id="element-256" data-mp="2jbkvw3tnyrz1">
          <div className="overflow-auto" style={{
          maxHeight: '600px'
        }} data-id="element-257" data-mp="2eane3sckfzy2">
            <table className="w-full border-collapse" data-id="element-258" data-mp="29cvc25i7ixg5">
              <thead data-id="element-259" data-mp="29eg5tswp6ccy">
                <tr data-id="element-260" data-mp="12w9u4ykxo4nb">
                  <th className="sticky top-0 left-0 z-20 bg-white border-b border-r border-gray-200" data-id="element-261" data-mp="12wt2poop1goo"></th>
                  {players.map(player => <th key={player.id} className="sticky top-0 z-10 bg-gray-50 border-b border-gray-200 p-3 min-w-[100px]" data-id="element-262" data-mp="xvlrtgr981ds">
                      <div className="flex flex-col items-center gap-2" data-id="element-263" data-mp="2y1iyudiuf8g7">
                        <img src={player.avatar} alt={player.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" onError={e => {
                      e.currentTarget.src = `https://via.placeholder.com/48x48/e5e7eb/6b7280?text=${player.name.charAt(0)}`;
                    }} data-id="element-264" data-mp="3303zuf5x5w5p" />
                        <span className="text-xs font-bold text-gray-900 uppercase" data-id="element-265" data-mp="3gqphy1nju22j">
                          {player.name}
                        </span>
                      </div>
                    </th>)}
                </tr>
              </thead>
              <tbody data-id="element-266" data-mp="3bypbrrgvycxi">
                {players.map(rowPlayer => <tr key={rowPlayer.id} data-id="element-267" data-mp="3bxeca3uh3rc7">
                    <th className="sticky left-0 z-10 bg-gray-50 border-r border-gray-200 p-3" data-id="element-268" data-mp="3jnq2l8buv5o">
                      <div className="flex items-center gap-2" data-id="element-269" data-mp="89uhsty4yvs5">
                        <img src={rowPlayer.avatar} alt={rowPlayer.name} className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-sm" onError={e => {
                      e.currentTarget.src = `https://via.placeholder.com/48x48/e5e7eb/6b7280?text=${rowPlayer.name.charAt(0)}`;
                    }} data-id="element-270" data-mp="8c75lnqks0d4" />
                        <span className="text-xs font-bold text-gray-900 uppercase" data-id="element-271" data-mp="1xr9flspbrbrk">
                          {rowPlayer.name}
                        </span>
                      </div>
                    </th>
                    {players.map(colPlayer => {
                  const duoInfo = getDuoValue(rowPlayer.id, colPlayer.id);
                  const isDiagonal = rowPlayer.id === colPlayer.id;
                  if (isDiagonal) {
                    return <td key={colPlayer.id} className="border border-gray-200 p-3 text-center bg-gray-100" data-id="element-272" data-mp="1ezytdoujnn60">
                            <span className="text-gray-300 text-lg font-bold" data-id="element-273" data-mp="2ufxmptzi5em7">
                              —
                            </span>
                          </td>;
                  }
                  if (!duoInfo) {
                    return <td key={colPlayer.id} className="border border-gray-200 p-3 text-center bg-gray-50" data-id="element-274" data-mp="2faux96o5hlk5">
                            <span className="text-xs text-gray-400" data-id="element-275" data-mp="2p6y1qj6h5wa9">—</span>
                          </td>;
                  }
                  return <td key={colPlayer.id} className="border border-gray-200 p-3 text-center cursor-pointer transition-all hover:ring-2 hover:ring-blue-400 hover:z-10" style={{
                    backgroundColor: getColorForValue(duoInfo.value)
                  }} onMouseEnter={e => showTooltip(e, rowPlayer, colPlayer, duoInfo)} onMouseLeave={hideTooltip} data-id="element-276" data-mp="2k739ocayr0nm">
                          <span className={`text-base ${getTextColor(duoInfo.value)}`} data-id="element-277" data-mp="32ym9ka9oxylf">
                            {duoInfo.value > 0 ? '+' : ''}
                            {duoInfo.value.toFixed(1)}
                          </span>
                        </td>;
                })}
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Tooltip */}
      {tooltip.visible && tooltip.data && <div className="fixed z-50 bg-gray-900 text-white rounded-lg shadow-2xl p-4 pointer-events-none" style={{
      left: tooltip.x + 15,
      top: tooltip.y + 15,
      maxWidth: '300px'
    }} data-id="element-278" data-mp="4drmi3hpiyp5">
          <div className="font-bold text-base mb-3 border-b border-gray-700 pb-2" data-id="element-279" data-mp="3ri7koqp51e0l">
            {tooltip.data.player1} + {tooltip.data.player2}
          </div>
          <div className="space-y-2 text-sm" data-id="element-280" data-mp="3hl2vsj3wr4g3">
            <div className="flex justify-between items-center" data-id="element-281" data-mp="3hm4gzgen17bj">
              <span className="text-gray-300" data-id="element-282" data-mp="33ug7lkvrwwy9">Shared Minutes</span>
              <span className="font-bold" data-id="element-283" data-mp="33s3fwg07r880">{tooltip.data.minutes} min</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-284" data-mp="38qwygmucxpf1">
              <span className="text-gray-300" data-id="element-285" data-mp="2tx1t3qteui8l">Possessions</span>
              <span className="font-bold" data-id="element-286" data-mp="2yuk3lln2t5ip">{tooltip.data.possessions}</span>
            </div>
            <div className="border-t border-gray-700 my-2" data-id="element-287" data-mp="2fpyh4kc88u1s"></div>
            <div className="flex justify-between items-center" data-id="element-288" data-mp="2frjcudaa2j18">
              <span className="text-gray-300" data-id="element-289" data-mp="2aygrgsfnmfw4">Net Rating</span>
              <span className={`font-bold text-lg ${tooltip.data.value >= 0 ? 'text-green-400' : 'text-red-400'}`} data-id="element-290" data-mp="260eztj45x891">
                {tooltip.data.value > 0 ? '+' : ''}
                {tooltip.data.value.toFixed(1)}
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-291" data-mp="2yokim0bnon68">
              <span className="text-gray-300" data-id="element-292" data-mp="2tpgdplvrlblp">Off Rating</span>
              <span className="font-semibold" data-id="element-293" data-mp="2to577eaxppqw">
                {tooltip.data.offRtg.toFixed(1)}
              </span>
            </div>
            <div className="flex justify-between items-center" data-id="element-294" data-mp="2jsbmv8qz4ryk">
              <span className="text-gray-300" data-id="element-295" data-mp="2ju67sn28wk2n">Def Rating</span>
              <span className="font-semibold" data-id="element-296" data-mp="1dcj2qdaolebq">
                {tooltip.data.defRtg.toFixed(1)}
              </span>
            </div>
          </div>
        </div>}
    </div>;
};
export default TeamComboDuos;